module.exports = __webpack_public_path__ + "static/media/nokia.949f16f1.jpg";